<template>
  <div class="ring-progress-modal">
    <div class="close" @click="close()">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.22037 1.28002C-0.0734566 0.986194 -0.0734566 0.511071 0.22037 0.22037C0.514196 -0.0703308 0.98932 -0.0734566 1.28002 0.22037L6 4.94035L10.72 0.22037C11.0138 -0.0734566 11.4889 -0.0734566 11.7796 0.22037C12.0703 0.514196 12.0735 0.98932 11.7796 1.28002L7.05965 6L11.7796 10.72C12.0735 11.0138 12.0735 11.4889 11.7796 11.7796C11.4858 12.0703 11.0107 12.0735 10.72 11.7796L6 7.05965L1.28002 11.7796C0.986194 12.0735 0.511071 12.0735 0.22037 11.7796C-0.0703308 11.4858 -0.0734566 11.0107 0.22037 10.72L4.94035 6L0.22037 1.28002Z" fill="white"/>
      </svg>
    </div>

    <transition-group
      name="fade-slide-bottom"
      tag="div"
      class="reveal-group"
      appear
    >
      <div :key="`dial`" class="dial"> 
        <UserTrack :size="120" :focus="opts.focus" />
      </div>

      <div :key="`inner`" class="ring-progress-inner">
        <h2>{{ opts.heading }}</h2>
        <p>{{ opts.paragraph }}</p>
      </div>

      <div :key="`actions`" class="actions">
        <button @click="close()" :class="opts.focus">Okay!</button>
      </div>
    </transition-group>

    <Lottie ref="lottie" :autoplay="true" animation="confetti-jump" :delay="250" />
  </div>
</template>

<script>
  import Lottie from '@/components/v5/Lottie.vue';
  import UserTrack from '@/components/v5/elements/UserTrack.vue';

  export default {
    props: {
      opts: {
        type: Object,
        default: null
      },
    },

    components: {
      Lottie,
      UserTrack,
    },

    mounted () {
      this.EventBus.$emit("device:haptic", 'light');
    },

    methods: {
      close() {
        this.$emit('close');
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .ring-progress-modal {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
    padding: 1.5rem 1.5rem 6.5rem 1.5rem;
    color: white;
    background: black;
    border-top: 1px solid rgba($neutral-400, 0.25);
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    max-width: 900px;
    margin: 0 auto;

    .close {
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: flex-end;
      width: 44px;
      height: 44px;
      background: black;
      border: 1px solid rgba($neutral-400, 0.2);
      border-radius: 500px;
    }

    .dial {
      display: flex;
      justify-content: center;
      margin-bottom: 1rem;
    }

    .ring-progress-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      padding-bottom: 1.5rem;
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
      text-align: center;

      svg {
        margin-bottom: 1rem;
      }

      h2 {
        font-family: 'Circular';
        font-size: 1.6rem;
        font-weight: bold;
        text-align: center;
      }

      p {
        font-size: 1rem;
        text-align: center;
      }
    }

    .actions {
      display: flex;
      width: 100%;

      button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        margin-top: 0.5rem;
        height: 55px;
        border-radius: 10px;
        font-size: 1rem;
        padding-top: 0.8rem;
        width: 100%;
        background-size: cover;
        color: rgba(0,0,0);

        svg path {
          fill: rgb(0,0,0);
        }

        &.time {
          background: $time-tone;
        }

        &.topics {
          background: $topics-tone;
        }

        &.locales {
          background: $locales-tone;
        }
      }
    }
  }

  .reveal-group > *:nth-child(2) {
    transition-delay: 0.10s;
  }
  .reveal-group > *:nth-child(3) {
    transition-delay: 0.25s;
  }
  .reveal-group > *:nth-child(4) {
    transition-delay: 0.40s;
  }
</style>